import React from "react";

const TemplateCard = ({ template, isSelected, onClick }) => {
  let activities = [];
  if (template.activities && Array.isArray(template.activities)) {
    activities = template.activities;
  } else {
    try {
      if (
        template.activities &&
        template.activities !== "null" &&
        template.activities !== "[]"
      ) {
        const parsed = JSON.parse(template.activities);
        activities = Array.isArray(parsed) ? parsed : [];
      }
    } catch (error) {
      activities = [];
    }
  }

  const formatTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";
    const date = new Date(dateTimeStr);
    return date
      .toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      });
  };

  const startTime = template.start_time ? formatTime(template.start_time) : "";
  const endTime = template.end_time ? formatTime(template.end_time) : "";
  const timeDisplay = startTime && endTime ? `${startTime}-${endTime}` : "";

  const getBorderColor = () => {
    if (isSelected) {
      return "ring-2 ring-brand-primary ";
    }
    return "ring-1 ring-gray-100 dark:ring-gray-700 ";
  };

  return (
    <div className="my-2 group">
      <div
        onClick={onClick}
        className={`w-full max-w-full overflow-hidden bg-white dark:bg-gray-800 rounded-md text-left px-3 py-2 cursor-pointer transition-all duration-200
        ${getBorderColor()}${
          isSelected ? " bg-brand-50/30 dark:bg-brand-primary/10" : ""
        } hover:bg-brand-50/5 dark:hover:bg-white/[0.04]`}
      >
        <div className="w-full max-w-full overflow-hidden flex items-center justify-between min-h-[35px]">
          <div className="flex-1 min-w-0 flex flex-col">
            <h3
              className="block truncate whitespace-nowrap overflow-hidden text-sm font-medium text-gray-700 dark:text-gray-200 w-full max-w-full"
              title={template.name}
            >
              {template.name}
            </h3>
            <div className="flex items-center text-xs text-gray-500 dark:text-gray-400">
              {timeDisplay && (
                <div className="flex items-center pr-2">
                  <span>{timeDisplay}</span>
                </div>
              )}
              <div className="flex items-center">
                <span>
                  {activities.length}{" "}
                  {activities.length === 1 ? "activity" : "activities"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { TemplateCard };
